module.exports = new __parcel__URL__("ConfluenceStandardOfferAIModalRightSide.7551cf90.svg").toString();